import { GetOrderResponse } from '@spilca/order_ts/v1/order/model_order_pb';
import { useQuery } from '@tanstack/react-query';
import { TGRPCPromiseReject } from '@monorepo/grpc';
import { QUERY_KEYS } from '@monorepo/helpers';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

const useGetOrder = (
  id: number
) => {
  const requestPromise = useGetRequest(REQUEST_TYPES.GET_ORDER);
  const request = () => requestPromise(id);

  return useQuery<GetOrderResponse.AsObject, TGRPCPromiseReject>({
    queryKey: [QUERY_KEYS.ORDER, id],
    queryFn: request,
    staleTime: 10*60*1000,
    gcTime: 60*1000,
    refetchOnWindowFocus: false,
    retry: false
  });
};

export default useGetOrder;
